"use client";

import { Mail } from "lucide-react";
import {
  DISCORD_INVITE_URL,
  SUPPORT_EMAIL,
} from "modules/common/constants/support";
import DiscordIcon from "modules/common/components/Icons/DiscordIcon";
import { ICON_SIZE } from "modules/common/components/navigation/Menu";

interface ErrorSupportInfoProps {
  className?: string;
}

export function ErrorSupportInfo({ className }: ErrorSupportInfoProps) {
  return (
    <div className={className}>
      <div className="divider text-base-content/50 text-xs">
        Still need help?
      </div>
      <div className="flex flex-wrap items-center justify-center gap-3">
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          className="btn btn-soft btn-sm btn-primary"
        >
          <Mail size={ICON_SIZE} aria-hidden />
          Email Us
        </a>
        <a
          href={DISCORD_INVITE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-discord btn-sm"
        >
          <DiscordIcon fontSize={ICON_SIZE} />
          Discord
        </a>
      </div>
    </div>
  );
}
